export class ParseError extends Error {
  constructor(message) {
    super(message);
    this.message = message;
    this.name = 'ParseError';
  }
}